export const UPDATE_PARTICIPANTS_BY_CAMERA_STATE = "IISIGHT_UPDATE_PARTICIPANTS_BY_CAMERA_STATE";
export const UPDATE_CAMERA_INACTIVE_PARTICIPANTS = "IISIGHT_UPDATE_CAMERA_INACTIVE_PARTICIPANTS";
export const UPDATE_CAMERA_ACTIVE_PARTICIPANTS = "IISIGHT_UPDATE_CAMERA_ACTIVE_PARTICIPANTS";
